module.exports = __webpack_public_path__ + "img/logo.a9e2af53.svg";